import { ColumnsType } from 'antd/lib/table';

import { CombinedKeyMap } from 'app/libs/combined-key-map/combined-key-map';

import { TRouteStationZoneGrid } from '../../core/route-station-zones';

export const createZoneStationDataMap = (data: TRouteStationZoneGrid) => {
  const tariffZonesMap = Object.fromEntries(
    data.tariffZones.map((item) => [item.id, item]),
  );

  const routeStationsMap = Object.fromEntries(
    data.routeStations.map((item) => [item.station.id, item.station]),
  );
  const createDataMapKey = CombinedKeyMap.createKeyBuilder([
    'stationFromId',
    'stationToId',
  ]);
  const dataMapContent = data.routeStationZones.map((item) => {
    const key = createDataMapKey({
      stationFromId: item.stationFromId,
      stationToId: item.stationToId,
    });
    const value = {
      zoneId: item.zoneId,
      zoneName: tariffZonesMap[item.zoneId].nameRu,
      stationFromName: routeStationsMap[item.stationFromId].nameRu,
    };
    return [key, value] satisfies [
      string,
      { stationFromName: string; zoneId: number; zoneName: string },
    ];
  });

  const stationZonesDataMap = new CombinedKeyMap<
    {
      stationFromId: number;
      stationToId: number;
    },
    { zoneId: number; zoneName: string }
  >({ keyBuilder: createDataMapKey, data: dataMapContent });

  const rows = data.routeStations;

  type RowType = (typeof rows)[number];

  const cols: ColumnsType<RowType> = [
    {
      key: 'stationNames',

      title: () => (
        <span style={{ fontWeight: 'normal' }}>Станции назначения</span>
      ),
      render: (_: any, record: RowType) => {
        return <span style={{ fontWeight: 500 }}>{record.station.nameRu}</span>;
      },
    },
    {
      key: 'stationFrom',
      title: () => (
        <span style={{ fontWeight: 'normal' }}>Станции отправления</span>
      ),
      children: data.routeStations.map(({ station }) => ({
        title: () => (
          <span style={{ whiteSpace: 'nowrap' }}>{station.nameRu}</span>
        ),
        with: '1%',
        key: `station-${station.id}`,
        render: (_: any, record: RowType) => {
          if (!record) return null;

          const zone = stationZonesDataMap.getRecord({
            stationFromId: station.id,
            stationToId: record.station.id,
          });

          return (
            <span style={{ whiteSpace: 'nowrap' }}>
              {zone?.zoneName || '-'}
            </span>
          );
        },
      })),
    },
  ];

  return { rows, cols };
};
